import React, { ReactElement } from 'react';
import Styled from './Grid.styled';
import { ComponentProps as Props } from './Grid.types';

const Grid: React.FC<Props> = ({ children, mb = 2, cols = 12, ...props }): ReactElement<Props> => {
  return (
    <Styled mb={mb} cols={cols} {...props}>
      {children}
    </Styled>
  );
};

export default Grid;
